<template>
    <div class="device-ct">
        <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
        <div class="nav">
            <header class="module-title">
                <h1>医学儿童模型</h1>
            </header>

            <div class="ct-content">
                <article class="single-col-card">
                    <!-- 1. 标题 + 主轮播 -->
                    <h2 class="title_T">{{ titleT[0] }}</h2>
                    <div class="main-banner carImg">
                        <el-carousel>
                            <el-carousel-item v-for="item in imgUrl[0]" :key="item">
                                <img loading="lazy" class="carousel_img banner-img" :src="item" alt="4岁儿童全身放射仿真模体整体实拍图" />
                                <div class="banner-glow"></div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                    <!-- 2. 三段描述文字 -->
                    <section class="text-wrap">
                        <p class="text-content">{{ p[0] }}</p>
                        <p class="text-content">{{ p[1] }}</p>
                        <p class="text-content">{{ p[2] }}</p>
                    </section>

                    <!-- 3. 产品部件（内联flex完全保留！！不改动布局结构） -->
                    <h2 class="title_T">{{ titleT[1] }}</h2>
                    <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                        <el-image lazy class="proParts main-banner" :preview-src-list="imgUrl[1]"
                            v-for="item in imgUrl[1]" :key="item" :src="item" alt="儿童全身医学模体拆分部件展示" />
                    </div>

                    <!-- 4. 产品图片轮播 -->
                    <h2 class="title_T">{{ titleT[2] }}</h2>
                    <div class="main-banner proImg">
                        <el-carousel>
                            <el-carousel-item style="display: flex;justify-content: space-between"
                                v-for="(item, index) in imgUrl.slice(2, 5)" :key="index">
                                <img loading="lazy" class="forImg banner-img" v-for="iem in item" :key="iem" :src="iem" alt="儿科全身放射训练人体幻影模型实拍照片" />
                            </el-carousel-item>
                            <div class="banner-glow"></div>
                        </el-carousel>
                    </div>

                    <!-- 5. 产品特性标签，ul改造，内联样式完整保留，不会破坏布局 -->
                    <h2 class="title_T">{{ titleT[3] }}</h2>
                    <ul style="display: flex;flex-wrap: wrap;padding: 0 3px;gap: 2%;justify-content: space-between;margin:0;padding-inline-start:0;">
                        <li class="tagWidth" :style="{ marginBottom: tags.length - 1 == index ? '0' : '16px' }"
                            v-for="(tag, index) in tags" :key="tag">
                            <el-tag effect="dark">
                                <i class="el-icon-success"></i>
                                {{ tag }}
                            </el-tag>
                        </li>
                    </ul>

                </article>
            </div>
        </div>
    </div>
</template>

<script>
import PullDown from "@/components/home/pullDown.vue";

export default {
    props: {
        hidePullDown: {
            type: Boolean,
            default: false // 默认显示
        }
    },
    name: "FullBodyRadioModel",
    components: {
        PullDown
    },
    data() {
        return {
            wWidth: window.innerWidth,
            titleT: ['儿童全身模型', '——产品部件——', '——产品图片——', '——产品特性——', '——适用场景（X线,CT,MRI）——',],
            tags: [
                ' 儿科全身模型 ',
                ' 现实主义身体组织 ',
                ' 肩部可 360 度旋转，侧面可 180 度转动 ',
                ' 可活动的髋关节、膝盖和肘关节 ',
                ' 可拆卸头部、躯干和四肢 ',
                ' 可根据不同病理情况（病灶、肿瘤、感染等）进行定制 ',
                ' 透明或肤色外观 '
            ],
            p: [
                '儿科全身仿生模型是一种适用于医疗专业人员的X光/CT和MRI兼容训练工具。该模型以4岁儿童为原型设计，具有与真人等大的解剖结构，器官和骨骼准确划分成10个身体部位。可用于训练患者体位摆放技巧，并通过视觉评估优化扫描条件。主要用于练习各种患者体位固定技术。常被医学院和教学医院采购，用于培训放射科学生及其他医疗专业人员。',
                '在MRI应用方面，该标本组织具有逼真的T2弛豫时间值，因此本产品非常适合各种T2加权MRI成像方法。使用质子密度成像方法也能获得非常理想的结果。该标本仍可进行T1加权成像，但T1值的逼真程度较低，大约在100毫秒范围内。',
                '该假人设计基于一名身高40英尺（102厘米）的4岁儿童模型。此假人为等身、全身的人体形态假人，具有解剖学上高度逼真的器官和骨骼，由10个身体部位构成。假人重约20公斤，可用于视觉评估，以确定最佳扫描条件。骨架由专利环氧树脂复合材料制成的单独铸造骨骼构成。'
            ],
            imgUrl: [
                [
                    require('@/assets/phantom/22.1.png'),
                    require('@/assets/phantom/er.1.png'),
                ],
                [
                    require('@/assets/phantom/children3.jpg'),
                    require('@/assets/phantom/children8.jpg'),
                    require('@/assets/phantom/children9.jpg'),
                    require('@/assets/phantom/children7.jpg'),
                    require('@/assets/phantom/children10.jpeg'),
                ],
                [
                    require('@/assets/phantom/children5.jpg'),
                    require('@/assets/phantom/children6.jpg'),
                    require('@/assets/phantom/children7.jpg'),
                ],
                [
                    require('@/assets/phantom/children8.jpg'),
                    require('@/assets/phantom/children9.jpg'),
                    require('@/assets/phantom/children10.jpeg'),
                ],
                [
                    require('@/assets/phantom/children1.jpg'),
                    require('@/assets/phantom/children2.jpg'),
                    require('@/assets/phantom/children3.jpg'),
                ]
            ],
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.wWidth = window.innerWidth;
        }
    },
    created() {
    }
}
</script>

<style lang="scss" scoped>
.device-ct {
    width: 100%;
    padding: 1rem;
    margin-top: 80px;
    background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
    box-sizing: border-box;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    @media (max-width: 767px) {
        margin-top: 60px;
        padding: 0.5rem;
    }

    .nav {
        width: 60%;
        margin: 0 auto;
        border: none;
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(10px);
        box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
            0 8px 24px rgba(37, 75, 156, 0.06);
        transition: all 0.3s ease;
        overflow: hidden;
        margin-top: 20px;

        @media (max-width: 1024px) {
            width: 80%;
        }

        @media (max-width: 767px) {
            width: 100%;
            border-radius: 16px;
            box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
        }

        &:hover {
            box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
        }
    }

    .module-title {
        padding: 2.5rem 2rem 1.5rem;
        font-size: 1.75rem;
        font-weight: 700;
        color: #1a365d;
        text-align: center;
        letter-spacing: 0.04em;
        position: relative;
        background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        flex-wrap: wrap;

        h1 {
            margin: 0;
            font-size: inherit;
            font-weight: inherit;
        }

        @media (max-width: 767px) {
            font-size: 1.25rem;
            padding: 1.5rem 1rem 1rem;
            gap: 8px;
        }

        &::after {
            content: "";
            width: 100px;
            height: 4px;
            background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
            border-radius: 4px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .ct-content {
        padding: 2.5rem 3rem 3rem;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        gap: 48px;

        @media (max-width: 1024px) {
            padding: 2rem 2rem 2.5rem;
            gap: 36px;
        }

        @media (max-width: 767px) {
            padding: 1.5rem 1rem 1.5rem;
            gap: 28px;
        }
    }

    .single-col-card {
        background: #fff;
        display: flex;
        flex-direction: column;
        gap: 32px;
        width: 100%;
        margin: auto;
    }

    // 全局统一文字样式
    .text-content {
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 0.95rem;
        line-height: 2;
        color: #1e293b;
        text-align: justify;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1rem;
        border-left: 3px solid transparent;

        @media (max-width: 767px) {
            font-size: 0.85rem;
            line-height: 1.85;
            padding-left: 0.75rem;
        }

        &:first-of-type {
            margin-bottom: 2rem;
            border-left-color: #3b82f6;
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
            padding: 0.75rem 1rem 0.75rem 1.5rem;
            border-radius: 0 8px 8px 0;

            @media (max-width: 767px) {
                padding: 0.5rem 0.75rem 0.5rem 1rem;
            }
        }

        &:last-of-type {
            margin-bottom: 2rem;
            border-left-color: #3b82f6;
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
            padding: 0.75rem 1rem 0.75rem 1.5rem;
            border-radius: 0 8px 8px 0;

            @media (max-width: 767px) {
                padding: 0.5rem 0.75rem 0.5rem 1rem;
            }
        }
    }

    .title_T {
        font-size: 1.1rem;
        line-height: 2.2;
        color: #2563AF;
        margin: 0;
    }

    // 轮播大图统一样式
    .carImg.main-banner,
    .proImg.main-banner {
        position: relative;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
        width: 100%;
    }

    .banner-glow {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 45%;
        background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
        pointer-events: none;
        z-index: 1;
    }

    .banner-img {
        width: 100%;
        height: 100%;
        display: block;
        transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
        object-fit: cover;
        object-position: center 55%;

    }

    .main-banner:hover .banner-img {
        transform: scale(1.035);
    }

    :deep(.el-carousel__container) {
        height: 437px;
    }

    // 部件小图
    .proParts.main-banner {
        position: relative;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
        width: 18%;
        transition: all 0.3s ease;

        img {
            width: 100%;
            height: auto;
            transition: transform 0.4s ease;
        }

        &:hover img {
            transform: scale(1.04);
        }
    }

    .forImg {
        width: 32%;
        border-radius: 8px;
        overflow: hidden;
        transition: transform 0.4s ease;

        &:hover {
            transform: scale(1.04);
        }
    }

    .forImg+.forImg {
        margin-left: 20px;
    }

    // 标签区域
    .tagWidth {
        width: 48%;
        list-style: none;
    }

    :deep .el-tag {
        text-align: left;
        width: 40vh;
    }

    :deep .el-tag--dark {
        background-color: #0969B2;
        border-color: #0969B2;
    }

    .el-tag+.el-tag {
        margin-left: 20px;
    }

    // 轮播箭头穿透样式
    :deep .el-carousel__arrow {
        background-color: rgba(44, 139, 218, 0.53);
    }

    .proImg :deep .el-carousel__container {
        height: 37vh;
    }

    // 移动端适配
    @media only screen and (max-width: 767px) {
        .tagWidth {
            width: 100%;
        }

        .carImg :deep .el-carousel__container {
            height: 17vh;
        }

        .proImg :deep .el-carousel__container {
            height: 19vh;
        }

        .proParts {
            width: 47.5%;
        }

        .proParts:not(:last-child) {
            margin-bottom: 20px;
        }

        :deep .el-tag {
            width: 100%;
        }
    }
}

// 暗色模式适配
@media (prefers-color-scheme: dark) {
    .device-ct {
        background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

        .nav {
            background: rgba(20, 30, 50, 0.92);
            backdrop-filter: blur(12px);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

            .module-title {
                color: #93bbfc;
                background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);

                &::after {
                    background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
                }
            }

            .ct-content {
                background: #0f1a2e;

                .single-col-card {
                    background: #142033;
                }

                .text-content {
                    color: #c8d6e8;

                    &:first-of-type {
                        background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
                    }

                    &:last-of-type {
                        background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
                    }
                }

                .title_T {
                    color: #60a5fa;
                }
            }
        }
    }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752] {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
    color: #0f3059;
    background: transparent;
}
</style>